import { useState, useEffect } from 'react'

const Header = () => {
  const [activeLink, setActiveLink] = useState('inicio')
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2

      // Detectar si hay scroll para cambiar el estilo del header
      setIsScrolled(window.scrollY > 50)

      const planesSection = document.getElementById('planes')
      if (!planesSection) return

      const planesSectionTop = planesSection.offsetTop
      const planesSectionBottom = planesSectionTop + planesSection.offsetHeight

      if (scrollPosition >= planesSectionTop && scrollPosition < planesSectionBottom) {
        setActiveLink('planes')
      } else {
        setActiveLink('inicio')
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Llamar inmediatamente para establecer el estado inicial

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleClickInicio = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setActiveLink('inicio')
  }

  const handleClickPlanes = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const planesSection = document.getElementById('planes')
    if (planesSection) {
      planesSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <header
      className={`top-0 left-0 w-full z-[100]  transition-all duration-300 ${
        isScrolled ? 'fixed' : 'absolute'
      }`}
    >
      <div className="w-full">
        {/* Una sola pastilla que contiene todo */}
        <div
          className={`flex items-center justify-center gap-3 sm:gap-6 md:gap-10 px-2 sm:px-3 py-3 sm:py-4 md:py-5 w-full transition-all duration-300 rounded-bl-[20px] rounded-br-[20px] sm:rounded-bl-[30px] sm:rounded-br-[30px] backdrop-blur-[20px] lg:bg-white/20 ${
            isScrolled
              ? 'bg-white shadow-lg lg:shadow-none'
              : 'bg-white/20'
          }`}
        >
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              src="/assets/images/Logo ruky circulo rojo.svg"
              alt="Ruky"
              className="h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12"
            />
          </div>

          {/* Navigation */}
          <nav className="flex gap-1 sm:gap-2">
            <a
              href="#"
              onClick={handleClickInicio}
              className={`px-3 sm:px-4 md:px-6 py-1.5 sm:py-2 rounded-[20px] sm:rounded-[25px] text-xs sm:text-sm font-medium transition-all duration-300 ${
                activeLink === 'inicio'
                  ? 'bg-[white] text-[#212121]'
                  : isScrolled
                  ? 'text-[#212121]/80 hover:text-[#212121] lg:text-white/100 lg:hover:text-white'
                  : 'text-white/100 hover:text-white'
              }`}
            >
              Inicio
            </a>
            <a
              href="#planes"
              onClick={handleClickPlanes}
              className={`px-3 sm:px-4 md:px-6 py-1.5 sm:py-2 rounded-[20px] sm:rounded-[25px] text-xs sm:text-sm font-medium transition-all duration-300 ${
                activeLink === 'planes'
                  ? 'bg-[#FF3F34] text-white'
                  : isScrolled
                  ? 'text-[#212121]/80 hover:text-[#212121] lg:text-white/100 lg:hover:text-white'
                  : 'text-white/100 hover:text-white'
              }`}
            >
              Planes
            </a>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
